export default "__VITE_ASSET__y2t2Ha_7__"